export default function CTASection() {
  return (
    <section className="relative py-24 md:py-36 px-6 md:px-12 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20lifestyle%20product%20arrangement%20with%20fashion%20accessories%2C%20sneakers%2C%20sunglasses%20and%20a%20tablet%20on%20a%20clean%20white%20marble%20desk%20surface%2C%20bright%20natural%20window%20light%20flooding%20the%20scene%2C%20modern%20aspirational%20product%20photography%2C%20fresh%20energetic%20aesthetic%2C%20contemporary%20commercial%20composition%2C%20crisp%20clean%20shadows%2C%20high%20detail%20professional%20staging%20with%20vibrant%20color%20accents&width=1800&height=1000&seq=cta-bg-v2-main-01&orientation=landscape"
          alt="OOPBuy Spreadsheet full catalog access"
          title="Get full access to OOPBuy Spreadsheet"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-wide uppercase">
          Get Full Access
        </h2>
        <p className="mt-4 md:mt-5 text-sm md:text-lg text-white/75 font-light max-w-xl mx-auto leading-relaxed">
          Unlock the complete OOPBuy database. One spreadsheet, thousands of verified products across 14 curated categories.
        </p>
        <div className="mt-8 md:mt-10">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-9 py-4 bg-foreground-950 text-white rounded-full text-sm md:text-base font-semibold hover:bg-foreground-900 transition-all whitespace-nowrap cursor-pointer"
          >
            <span className="w-6 h-6 rounded-full bg-accent-500 flex items-center justify-center">
              <i className="ri-shopping-bag-3-line text-white text-xs w-3.5 h-3.5 flex items-center justify-center"></i>
            </span>
            BUY IT NOW
            <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
          </a>
        </div>
        <p className="mt-5 text-white/50 text-xs">
          Redirects to kaspreadsheet.com — your trusted product sourcing platform
        </p>
      </div>
    </section>
  );
}